import { Stack } from '@mui/material';
import LoadPanel from 'devextreme-react/load-panel';
import React from 'react';

const LoadingPanel = (props) => {
    return (
        <Stack justifyContent="center" alignItems="center" gap={1}>
            <LoadPanel shading shadingColor="rgba(0,0,0,0.2)" visible={true} {...props} />
        </Stack>
    );
};

export default LoadingPanel;
